import { keepPreviousData, useQuery } from "@tanstack/react-query";

import noteService from "@services/note.service";
import { RelationObjectType } from "@enums/relations.enum";
import { BOUND_NOTE_QUERY_KEY, QUERY_CACHE_SHORT_EXPIRATION_MS } from "@config/query";

export function useGetBoundNote(
  objectId: string,
  contentType: RelationObjectType,
  enabled: boolean = true
) {
  return useQuery({
    enabled: enabled && Boolean(objectId && objectId.length),
    queryKey: [BOUND_NOTE_QUERY_KEY, objectId],
    queryFn: async () => {
      if (contentType === RelationObjectType.EMAIL_THREAD) {
        return noteService.getThreadBoundNote(objectId);
      }
      return noteService.getMeetingBoundNote(objectId);
    },
    staleTime: QUERY_CACHE_SHORT_EXPIRATION_MS,
    retry: false,
    placeholderData: keepPreviousData,
  });
}
